import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { OEMUrls } from 'src/app/utils/apiUrls';

@Injectable({
  providedIn: 'root'
})
export class OemNetworkManagementService {
 
  private getOEMsList = OEMUrls.oem_list;
  private sendRequestUrl = OEMUrls.sendRequest;
  private getOemByOemIdUrl = OEMUrls.oemById;
  private sentPendingRequestUrl = OEMUrls.sentPendingRequest;
  private receivedPendingRequestUrl = OEMUrls.receivedPendingRequest;
  private getDistributorByDistributorIdUrl = OEMUrls.distributor;
  private respondRequestUrl = OEMUrls.respondRequest;
  private getOemsByDistributorId = OEMUrls.getOemsByDistributorId;

  
  constructor(private http: HttpClient) { }

  getAllOems(pageNumber?: number, pageSize?: number): Observable<any> {
    const params = new HttpParams()
      .set('page', pageNumber ? pageNumber.toString() : '0')
      .set('size', pageSize ? pageSize.toString() : '10');
    return this.http.get<any>(`${this.getOEMsList}`, { params }).pipe();
  }
  sendRequest(body: any): Observable<any> {
   return this.http.post<any>(`${this.sendRequestUrl}`, body).pipe();
  }

  getOemById(id: string): Observable<any> {
    return this.http.get<any>(`${this.getOemByOemIdUrl}${id}`).pipe();
  }
  getMyOemsByDistributorId(id: string): Observable<any> {
    return this.http.get<any>(`${this.getOemsByDistributorId}?id=${id}`).pipe();
  }


  getSentPendingRequests(id ?: string):Observable<any>{
    return this.http.get<any>(`${this.sentPendingRequestUrl}${id}`).pipe();
  }

  getReceivedPendingRequests(id ?: string):Observable<any>{
    return this.http.get<any>(`${this.receivedPendingRequestUrl}${id}`).pipe();
  }

  getDistributorById(id: string): Observable<any> {
    return this.http.get<any>(`${this.getDistributorByDistributorIdUrl}${id}`).pipe();
  }
  
  acceptRequest(id: string): Observable<any> {
    return this.http.post<any>(`${this.respondRequestUrl}/respond/${id}?status=ACCEPTED&remarks=`, null).pipe();
  }

  rejectRequest(id: string, remark: any): Observable<any> {
    return this.http.post<any>(`${this.respondRequestUrl}/respond/${id}?status=REJECTED&remarks=${remark}`, null).pipe();
  }
  cancelRequest(id: string): Observable<any> {
    return this.http.post<any>(`${this.respondRequestUrl}/respond/${id}?status=CANCELLED&remarks=`, null).pipe();
  }
  requestedDetails(data: any){
    return this.http.post<any>(`${OEMUrls.respondRequest}/requested-details`, data);
  }
}


